module.exports = __webpack_public_path__ + "img/102.8e21d318.jpg";